import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Wallet, Building, CheckCircle2, AlertCircle, ChevronRight } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { useVendor } from '../context/VendorContext';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorWithdrawalScreen() {
  const {
    goBack
  } = useNavigation();
  const {
    balance,
    store
  } = useVendor();
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const numAmount = parseFloat(amount.replace(/,/g, '')) || 0;
  const processingFee = 100;
  const totalDeduction = numAmount > 0 ? numAmount + processingFee : 0;
  const isValid = numAmount >= 1000 && totalDeduction <= balance;
  const handleWithdraw = () => {
    if (!isValid) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setShowSuccess(true);
      setTimeout(() => goBack(), 2000);
    }, 1500);
  };
  const setQuickAmount = (val: number) => {
    setAmount(val.toString());
  };
  if (showSuccess) {
    return <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col items-center justify-center p-6" data-id="element-2640">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} className="w-24 h-24 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-6" data-id="element-2641">
          <CheckCircle2 className="w-12 h-12 text-green-600 dark:text-green-400" data-id="element-2642" />
        </motion.div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-2643">
          Withdrawal Initiated
        </h2>
        <p className="text-center text-gray-500 dark:text-gray-400 mb-2" data-id="element-2644">
          Your request for ₦{numAmount.toLocaleString()} is being processed.
        </p>
        <p className="text-center text-sm text-gray-400 dark:text-gray-500" data-id="element-2645">
          Funds will arrive in your bank account within 24 hours.
        </p>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-10" data-id="element-2646">
      <Header title="Withdraw Funds" showBack data-id="element-2647" />

      <div className="p-4 space-y-6" data-id="element-2648">
        {/* Balance Card */}
        <div className="bg-gradient-to-br from-primary to-primary-600 p-6 rounded-2xl text-white shadow-lg text-center" data-id="element-2649">
          <Wallet className="w-8 h-8 mx-auto mb-3 opacity-80" data-id="element-2650" />
          <p className="text-sm text-white/80 mb-1" data-id="element-2651">Available Balance</p>
          <h2 className="text-4xl font-bold" data-id="element-2652">₦{balance.toLocaleString()}</h2>
        </div>

        {/* Amount Input */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-2653">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block mb-4 text-center" data-id="element-2654">
            Enter Amount to Withdraw
          </label>
          <div className="flex items-center justify-center border-b-2 border-gray-200 dark:border-gray-700 pb-2 mb-6 focus-within:border-primary transition-colors" data-id="element-2655">
            <span className="text-3xl font-bold text-gray-400 mr-2" data-id="element-2656">₦</span>
            <input type="number" value={amount} onChange={e => setAmount(e.target.value)} placeholder="0" className="text-4xl font-bold text-gray-900 dark:text-white bg-transparent w-full text-center focus:outline-none" data-id="element-2657" />
          </div>

          <div className="grid grid-cols-4 gap-2" data-id="element-2658">
            <button onClick={() => setQuickAmount(50000)} className="py-2 text-xs font-medium bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-300 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary hover:text-primary transition-colors" data-id="element-2659">
              50k
            </button>
            <button onClick={() => setQuickAmount(100000)} className="py-2 text-xs font-medium bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-300 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary hover:text-primary transition-colors" data-id="element-2660">
              100k
            </button>
            <button onClick={() => setQuickAmount(200000)} className="py-2 text-xs font-medium bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-300 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-primary hover:text-primary transition-colors" data-id="element-2661">
              200k
            </button>
            <button onClick={() => setQuickAmount(balance - processingFee)} className="py-2 text-xs font-medium bg-primary/10 text-primary rounded-lg border border-primary/20 hover:bg-primary/20 transition-colors" data-id="element-2662">
              All
            </button>
          </div>

          {numAmount > 0 && numAmount < 1000 && <p className="text-xs text-red-500 mt-4 text-center flex items-center justify-center gap-1" data-id="element-2663">
              <AlertCircle className="w-3 h-3" data-id="element-2664" /> Minimum withdrawal is ₦1,000
            </p>}
          {totalDeduction > balance && <p className="text-xs text-red-500 mt-4 text-center flex items-center justify-center gap-1" data-id="element-2665">
              <AlertCircle className="w-3 h-3" data-id="element-2666" /> Insufficient balance
              (including fee)
            </p>}
        </div>

        {/* Bank Details */}
        <div className="bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 flex items-center justify-between" data-id="element-2667">
          <div className="flex items-center gap-3" data-id="element-2668">
            <div className="w-10 h-10 bg-gray-50 dark:bg-gray-900 rounded-full flex items-center justify-center" data-id="element-2669">
              <Building className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-2670" />
            </div>
            <div data-id="element-2671">
              <p className="text-sm font-bold text-gray-900 dark:text-white" data-id="element-2672">
                {store.bankDetails?.bankName || 'No Bank Added'}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-2673">
                {store.bankDetails?.accountNumber ? `•••• ${store.bankDetails.accountNumber.slice(-4)}` : 'Add bank details first'}
              </p>
            </div>
          </div>
          <button className="text-xs font-medium text-primary" data-id="element-2674">Change</button>
        </div>

        {/* Summary */}
        <div className="bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 space-y-3" data-id="element-2675">
          <div className="flex justify-between text-sm" data-id="element-2676">
            <span className="text-gray-500 dark:text-gray-400" data-id="element-2677">
              Withdrawal Amount
            </span>
            <span className="font-medium text-gray-900 dark:text-white" data-id="element-2678">
              ₦{numAmount.toLocaleString()}
            </span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-2679">
            <span className="text-gray-500 dark:text-gray-400" data-id="element-2680">
              Processing Fee
            </span>
            <span className="font-medium text-gray-900 dark:text-white" data-id="element-2681">
              ₦{processingFee.toLocaleString()}
            </span>
          </div>
          <div className="pt-3 border-t border-gray-100 dark:border-gray-700 flex justify-between" data-id="element-2682">
            <span className="font-bold text-gray-900 dark:text-white" data-id="element-2683">
              Total Deduction
            </span>
            <span className="font-bold text-primary text-lg" data-id="element-2684">
              ₦{totalDeduction.toLocaleString()}
            </span>
          </div>
        </div>

        <Button fullWidth size="lg" onClick={handleWithdraw} loading={loading} disabled={!isValid || !store.bankDetails?.accountNumber} className="bg-primary hover:bg-primary/90 text-white shadow-lg shadow-primary/20" data-id="element-2685">
          Withdraw Funds
        </Button>
      </div>
    </div>;
}